import * as api from "../../shared/api";
import * as biz_data_helper from "../../shared/biz_data_helper";

const content_type = "RouteVersion";

const create = function () {
  return {
    content_type: "muji",
    age: 29
  };
};
const descriptor = {};

const biz_data = new biz_data_helper.base_entity_helper(
  content_type,
  create,
  descriptor
);

const fields = {
  default: [
    {
      key: "id",
      label: "编号",
      sortable: true,
      type: "button",
      button: {
        type: "text"
      },
      thStyle: { width: "60px" }
    },
    {
      key: "dataAreaId",
      label: "销售公司",
      sortable: true,
      thStyle: {
        width: "5rem"
      }
    },
    {
      key: "CompanyName",
      label: "销售公司名称",
      sortable: true,
      thStyle: { width: "8rem" },
      width: "8rem",
      type: "short"
    },
    { key: "RouteId", label: "工艺路线编号", sortable: true },
    {
      key: "Name", label: "工艺路线版本名称", sortable: true, thStyle: { width: "12rem" },
      width: "12rem",
      type: "short"
    },
    { key: "ItemId", label: "物料编号", sortable: true },
    {
      key: 'NameAlias', label: '物料名称', sortable: true, thStyle: { width: "12rem" },
      width: "12rem",
      type: "short"
    },

    { key: "FromQty", label: "最小批量", type: "number", _precise: 0, },

    { key: 'create_by_username', label: '创建人', sortable: true },
    { key: 'create_at', label: '创建时间', sortable: true, type: "date" },
    { key: 'Active', label: '有效', sortable: true, type: "boolean" },
    { key: 'is_approved', label: '审批', sortable: true, type: "boolean" },
    {
      key: 'approved_by_username', label: '审批人', sortable: true,
      formatter: (value, key, item) => {
        if (item.is_approved) {
          return item.approved_by_username;
        } else {
          return "";
        }
      }
    },
    { key: 'LastAsyncDate', label: '最近同步时间', sortable: true, type: "datetime" },
  ]
};

const dataForm = {};

///前端验证
const rules = {};
const methods = {
  ///get
  async getData(_params) {
    let version_biz_data = new biz_data_helper.base_entity_helper("get_route_version_by_searchtext", {}, {});
    let f = _.map(fields.default, "key");
    let result = await version_biz_data
      .execAction({
        params: _params,
        fields: f
      }).run();

    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data;
    } else {
      return null;
    }
  },
  async getDataDiff(_params) {
    let f = _.map(fields.default, "key");
    let result = await biz_data
      .selectAction({
        params: _params,
        fields: f
      }).run();

    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data;
    } else {
      return null;
    }
  },
  async saveDataRouteVersion(params) {

    let _actions = [];
    for (var k in params) {
      if (k == "add") {
        _actions.push(
          biz_data.insertAction({
            params: params[k],
            fields: _.map(fields.default, "key")
          }).action({})
        );
      }
      else if (k == "edit") {
        _actions.push(
          biz_data.updateAction({
            params: params[k],
            fields: _.map(fields.default, "key")
          }).action({})
        );
      }
      else if (k == "valid") {
        if (params.action_state) {
          const ensure_active_biz_data = new biz_data_helper.base_entity_helper("route_uniq_active", {}, {});
          _actions.push(
            ensure_active_biz_data.execAction({
              params: params[k],
              fields: _.map(fields.default, "key")
            }).action({})
          );
        }
        _actions.push(
          biz_data.updateAction({
            params: params[k],
            fields: _.map(fields.default, "key")
          }).action({})
        );
      }
      else if (k == "delete") {
        _actions.push(
          biz_data.removeAction({
            params: params[k],
            fields: _.map(fields.default, "key")
          }).action({})
        );
      }
      else if (k == "approved") {
        _actions.push(
          biz_data.approveAction({
            params: params[k],
            fields: _.map(fields.default, "key")
          }).action({})
        );
      }
      else if (k == "copy") {
        const copy_biz_data = new biz_data_helper.base_entity_helper("copy_route", {}, {});
        _actions.push(
          copy_biz_data.execAction({
            params: params[k],
            fields: []
          }).action({})
        );
      }
    }
    let result = await api.query_batch({
      actions: _actions
    });
    if (
      result &&
      result.data &&
      result.data.BatchResult &&
      result.data.BatchResult.Actions &&
      result.data.BatchResult.Actions.length > 0
    ) {
      if (params.valid && params.valid.length > 0) {
        return result.data.BatchResult.Actions[1].Result.Data[0];
      }
      return result.data.BatchResult.Actions[0].Result.Data[0];
    } else {
      return null;
    }
  },
  //获取同步数据
  async getAsyncData(_params) {
    let item_biz_data = new biz_data_helper.base_entity_helper(
      "ax_bom_or_route",
      {},
      {}
    );
    let result = await item_biz_data
      .handlerScriptAction({
        params: _params
      })
      .run();
    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data;
    } else {
      return null;
    }
  },
};
export { biz_data, dataForm, fields, methods, rules };

